const spacingVariants = {
  '20px': '20px',
  '70px': '70px',
}

const colors = {
  // updated colors
  black: '#3D3E46',
  'off-black': '#231F20',
  'base-white': '#FFFFFF',
  'cool-white': '#F8F8FA',
  'cool-white-2': '#F0F0F3',
  // coolGrey
  'coolGrey-50': '#F8F8FA',
  'coolGrey-100': '#DEDEE5',
  'coolGrey-200': '#A1A0A9',
  'coolGrey-300': '#78777F',
  'coolGrey-400': '#4E4F57',
  'coolGrey-500': '#45464E',
  'coolGrey-600': '#3D3E46',
  'coolGrey-700': '#231F20',
  'coolGrey-800': '#141418',
  'coolGrey-900': '#0D0D10',
  // blue
  'blue-50': '#EEF4FA',
  'blue-100': '#D7E7F4',
  'blue-200': '#ABCDE8',
  'blue-300': '#7FB3DC',
  'blue-400': '#5399D0',
  'blue-500': '#327DB9',
  'blue-600': '#276291',
  'blue-700': '#1C4769',
  'blue-800': '#112C41',
  'blue-900': '#071018',
  'blue-royal': 'rgba(50, 125, 185, 0.4)',
  // indigo
  'indigo-50': '#E1EEF7',
  'indigo-100': '#ABCDE8',
  'indigo-200': '#58A2D4',
  'indigo-300': '#338BC6',
  'indigo-400': '#3A7297',
  'indigo-500': '#286E9E',
  'indigo-600': '#1E5275',
  'indigo-700': '#183A59',
  'indigo-800': '#15324D',
  'indigo-900': '#122B41',
  // emerald
  'emerald-50': '#E3F2F6',
  'emerald-100': '#D0E9EF',
  'emerald-200': '#A9D7E3',
  'emerald-300': '#83C5D6',
  'emerald-400': '#65C5DD',
  'emerald-500': '#3C9EB7',
  'emerald-600': '#2F7D91',
  'emerald-700': '#0B667F',
  'emerald-800': '#163B44',
  'emerald-900': '#0A191D',
  // violet
  'violet-50': '#F2EAF0',
  'violet-100': '#E8DBE5',
  'violet-200': '#D5BBCF',
  'violet-300': '#C19CB9',
  'violet-400': '#AD7DA3',
  'violet-500': '#985F8C',
  'violet-600': '#794B6F',
  'violet-700': '#593852',
  'violet-800': '#3A2435',
  'violet-900': '#1A1118',
  // amber
  'amber-50': '#F5F2EF',
  'amber-100': '#F1E1CF',
  'amber-200': '#FEF8F7',
  'amber-300': '#F8D3CA',
  'amber-400': '#F3AE9C',
  'amber-500': '#ED896F',
  'amber-600': '#E76442',
  'amber-700': '#DB431B',
  'amber-800': '#AD3516',
  'amber-900': '#802710',
  // equity
  equity: '#41937D',
  'equity-50': '#B0DCD0',
  'equity-100': '#A2D6C8',
  'equity-200': '#85C9B7',
  'equity-300': '#69BDA6',
  'equity-400': '#4EAF95',
  'equity-500': '#41937D',
  'equity-600': '#306C5C',
  'equity-700': '#1F453B',
  'equity-800': '#0D1E1A',
  'equity-900': '#0A1714',
}

module.exports = {
  mode: 'jit',
  purge: [
    // 'components/**/*.vue',
    // 'layouts/**/*.vue',
    // 'pages/*.vue',
    './safelist.txt',
  ],
  // purge: {
  //   content: ['./**/*.vue', './safelist.txt'],
  //   safelist: [
  //     'mb-[132px]',
  //     'mb-72',
  //     'mb-40',
  //     'mb-11',
  //     'mb-12',
  //     'pb-24',
  //     'pt-40',
  //     'pt-44',
  //     'py-11',
  //     'py-12',
  //     'py-24', // 96px
  //     'md:py-24', // 96px
  //     'md:mb-40',
  //     'md:mb-[132px]',
  //     'md:py-16',
  //   ],
  //   options: {
  //     keyframes: true,
  //     fontFace: true,
  //   },
  // },
  theme: {
    extend: {
      lineClamp: {
        7: '7',
        8: '8',
        9: '9',
        10: '10',
      },
      fontFamily: {
        Mazzard: '"Mazzard Soft M", sans-serif',
        MazzardLight: '"Mazzard Soft M Light", sans-serif',
        MazzardSemiBold: '"Mazzard Soft M Semi Bold", sans-serif',
        FtMade: '"FtMade", sans-serif',
        OldschoolGrotesk: '"Oldschool Grotesk Compressed", sans-serif',
        arial: 'arial',
        sans: 'sans-serif',
        Helvetica: 'Helvetica',
      },
      fontSize: {
        '16px': '16px',
        '22px': '22px',
        '24px': '24px',
        '28px': '28px',
        '34px': '34px',
        '38px': '38px',
        '80px': '80px',
      },
      flex: {
        '50%': '0 0 50%',
        '25%': '0 0 25%',
      },
      colors: {
        ...colors,
        iwbi: {
          'cool-white': '#F8F8FA',
          'cool-white-2': '#F0F0F3',
          'cool-gray': '#504F62',
          'cool-gray-1': '#A8A6B8',
          'cool-gray-2': '#78777F',
          'cool-gray-3': '#3D3E46',
          'cool-gray-4': '#A1A0A9',
          'light-gray': '#DEDEE5',
          'gray-2': '#F7FAFD',
          'gray-3': '#828192',
          'off-black': '#231F20',
          'soft-black': '#51525C',
          'cool-purple-2': '#797691',
          'rose-gold': '#F1E1CF',
          'blue-1': '#327DB9',
          'blue-2': '#ABCDE8',
          'blue-3': '#E1EEF7',
          'blue-4': '#1E5275',
          'blue-5': '#276291',
          'blue-6': '#D7E7F4',
          'blue-7': '#7FB3DC',
          'light-blue-1': '#1483C5',
          'dark-blue-1': '#1F45D2',
          'dark-blue-2': '#032955',
          indigo: '#338BC6',
          'indigo-2': '#58A2D4',
          'teal-1': '#3C9EB7',
          'teal-2': '#0B667F',
          'teal-3': '#65C5DD',
          'purple-1': '#985F8C',
          emerald: '#2F7D91',
          'emerald-1': '#5CB3CA',
          'well-beige': '#EDDAC3',
          salmon: '#ED896F',
          'hover-gray': '#d0cfd7',
        },
      },
      inset: {},

      // grid
      gridTemplateRows: {
        'directory-card': '1fr 1fr auto',
      },
      gridTemplateColumns: {
        auto: 'auto minmax(0,1fr)',
      },
      gridColumn: {
        full: 'full',
        container: '2/14',
      },
      gridColumnStart: {
        14: '14',
        full: 'full',
      },
      gridColumnEnd: {
        14: '14',
        full: 'full',
      },
      // end grid

      letterSpacing: {
        'wide-light': '.01em',
      },
      margin: spacingVariants,
      padding: spacingVariants,
      borderRadius: {
        '2.5rem': '2.5rem',
        '2.75rem': '2.75rem',
        '3rem': '3rem',
        '20px': '20px',
      },
      boxShadow: {
        1: '0px 4px 12px rgba(63, 58, 72, 0.07)',
        2: '0px 20px 80px rgba(63, 58, 72, 0.07)',
        lift: '0px 2px 12px rgba(63, 58, 72, 0.07)',
        card: '0 13px 27px -5px rgba(50,50,93,0.25),0 8px 16px -8px rgba(0,0,0,0.3)',
      },
      keyframes: {
        'fade-in-down': {
          '0%': {
            opacity: '0',
          },
          '100%': {
            opacity: '1',
          },
        },
      },
      animation: {
        'fade-in-down': 'fade-in-down 0.5s ease-out',
      },
      width: {
        'indented-width-2xl': 'calc(100vw - ((100vw - 1140px + 8px) / 2))',
        'indented-width-xl': 'calc(100vw - ((100vw - 960px + 8px) / 2))',
        'indented-width-lg': 'calc(100vw - ((100vw - 768px + 8px) / 2))',
        'indented-width-md': 'calc(100vw - ((100vw - 704px + 8px) / 2))',
        'indented-width-sm': 'calc(100vw - ((100vw - 576px + 8px) / 2))',
      },
      minHeight: {
        inherit: 'inherit',
      },
    },
    minWidth: {
      'iwbi-unset': 'unset',
      'iwbi-80vw': '80vw',
    },

    maxWidth: {
      'iwbi-unset': 'unset',
      'iwbi-max-width': '1920px',
      'iwbi-120px': '120px',
      'iwbi-80vw': '80vw',
      modal: '958px',
    },
    maxHeight: {
      'iwbi-80px': '80px',
    },
  },
  plugins: [
    function ({ addComponents }) {
      addComponents({
        '.container': {
          width: '100%',
          '@screen sm': {
            maxWidth: '576px',
          },
          '@screen md': {
            maxWidth: '704px',
          },
          '@screen lg': {
            maxWidth: '768px',
          },
          '@screen xl': {
            maxWidth: '960px',
          },
        },
        '.container-grid': {
          display: 'grid',
          gridTemplateColumns: `[full-start] minmax(32px, 1fr) repeat(12, [c-start] minmax(0, 1fr) [c-end]) minmax(32px, 1fr) [full-end]`,
          '@screen sm': {
            gridTemplateColumns: `[full-start] minmax(32px, 1fr) repeat(12, [c-start] minmax(auto, calc(576px / 12)) [c-end]) minmax(32px, 1fr) [full-end]`,
          },
          '@screen md': {
            gridTemplateColumns: `[full-start] minmax(32px, 1fr) repeat(12, [c-start] minmax(auto, calc(704px / 12)) [c-end]) minmax(32px, 1fr) [full-end]`,
          },
          '@screen lg': {
            gridTemplateColumns: `[full-start] minmax(32px, 1fr) repeat(12, [c-start] minmax(auto, calc(768px / 12)) [c-end]) minmax(32px, 1fr) [full-end]`,
          },
          '@screen xl': {
            gridTemplateColumns: `[full-start] minmax(32px, 1fr) repeat(12, [c-start] minmax(auto, calc(960px / 12)) [c-end]) minmax(32px, 1fr) [full-end]`,
          },
        },
      })
    },
    require('@tailwindcss/line-clamp'),
    require('@tailwindcss/aspect-ratio'),
    // require('tailwind-safelist-generator')({
    //   path: 'safelist.txt',
    //   patterns: [
    //     'text-{colors}',
    //     'bg-{colors}',
    //     'hover:text-{colors}',
    //     'hover:bg-{colors}',
    //     'pt-{padding}',
    //     'pb-{padding}',
    //     'pl-{padding}',
    //     'pr-{padding}',
    //     'mt-{margin}',
    //     'mb-{margin}',
    //     'ml-{margin}',
    //     'mr-{margin}',
    //     '{screens}:pt-{padding}',
    //     '{screens}:pb-{padding}',
    //     // '{screens}:pl-{padding}',
    //     // '{screens}:pr-{padding}',
    //     '{screens}:mt-{margin}',
    //     '{screens}:mb-{margin}',
    //     // '{screens}:ml-{margin}',
    //     // '{screens}:mr-{margin}',
    //   ],
    // }),
  ],
}
